import {
  extend,
  groupedTranslations,
  setLocalizationConfigurations,
} from "@mongez/localization";
import {
  arValidationTranslation,
  enValidationTranslation,
} from "@mongez/react-form";
import { jsxConverter } from "@mongez/react-localization";
import aboutUs from "./about-us.json";
import account from "./account.json";
import auth from "./auth.json";
import cart from "./cart.json";
import checkout from "./checkout.json";
import common from "./common.json";
import contactUs from "./contact-us.json";
import ourCakes from "./our-cakes.json";
import seo from "./seo.json";
import wishlist from "./wishlist.json";

const languages = ["en", "ar"];

export const supportedLanguages = [...languages];

export type Language = (typeof languages)[number];

export const returnLanguageIfSupported = (
  lang?: string,
): Language | undefined => {
  if (supportedLanguages.includes(lang as Language)) {
    return lang as Language;
  }
  return undefined;
};

setLocalizationConfigurations({
  converter: jsxConverter,
  defaultLocaleCode: "en",
});

// Validation translations
extend("en", { validation: enValidationTranslation });
extend("ar", { validation: arValidationTranslation });

// Modules translations
groupedTranslations(common);
groupedTranslations(ourCakes);
groupedTranslations(wishlist);
groupedTranslations("cart", cart);
groupedTranslations("auth", auth);
groupedTranslations("checkout", checkout);
groupedTranslations(account);
groupedTranslations("seo", seo);
groupedTranslations("aboutUsPage", aboutUs);
groupedTranslations("contactUsPage", contactUs);
